import React from 'react'
import AccessibilityIcon from '../../assets/images/icons/accessibility-icon.svg'

function Accessibility() {
  return (
    <li>
      <a
        href="https://www.essentialaccessibility.com/avant"
        className="accessibility-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={AccessibilityIcon}
          alt="This icon serves as a link to download the eSSENTIAL Accessibility assistive technology app for individuals with physical disabilities. It is featured as part of our commitment to diversity and inclusion."
        />
      </a>
    </li>
  )
}

export default Accessibility
